<template>
    <div class="alarm-collapse-group">
        <el-collapse-item
            v-for="alarm in alarmsToDisplay"
            :title="alarm.name"
            :name="alarm.uid"
            :key="alarm.uid"
            :class="setCollapseClass(alarm)">
            <template slot="title">
                <div class="alarm-collapse-header-title">
                    {{ alarm.name }}
                    <span v-if="alarm.active && alarm.message.length <= 50">
                        ({{ alarm.message }})
                    </span>
                    <i v-if="alarm.active" class="header-icon el-icon-warning"></i>
                </div>
            </template>
            <alarm-collapse-content :alarm="alarm"></alarm-collapse-content>
        </el-collapse-item>
    </div>
</template>

<script>

import AlarmCollapseContent from './alarmCollapseContent.vue';
export default {

    components: { AlarmCollapseContent },

    props: {
        alarmsToDisplay: {
            type: Array,
            required: true,
        }
    },

    methods: {
        setCollapseClass(alarm) {
            return alarm.active ? 'alarm-collapse-active' : 'alarm-collapse-not-active';
        },
    }
};
</script>

<style lang="scss">

.alarm-collapse-header-title {
    margin-left: 20px;
}

.header-icon {
    margin-left: 5px;
}

.alarm-collapse-group {
    margin-bottom: 10px;
}

.alarm-collapse-header-title {
    margin-left: 20px;
}

.el-collapse-item__header {
    color: #fff;
}

.el-collapse-item__content {
    color: #fff;
    font-weight: 500;
}

.alarm-collapse-active .el-collapse-item__header {
    background-color: #e25950;
}

.alarm-collapse-active .el-collapse-item__content {
    background-color: #E46359;
}

.alarm-collapse-not-active .el-collapse-item__header {
    background-color: #26a686;
}

.alarm-collapse-not-active .el-collapse-item__content {
    background-color: #41BF9F;
}
</style>



// WEBPACK FOOTER //
// node_modules/fundation-app-vuejs/src/components/pages/alarms/alarmCollapseItem.vue